export enum APLTranslationCodes {
  hp_authorized_partner_registration = 'apl:hp_authorized_partner_registration',
  hp_respect_your_privacy = 'apl:hp_respect_your_privacy',
  email_validation = 'apl:email_validation',
  language = 'apl:language',
  country_of_business = 'apl:country_of_business',
  email_address = 'apl:email_address',
  company_data = 'apl:company_data',
  company_legal_name = 'apl:company_legal_name',
  required = 'apl:required',
  state = 'apl:state',
  zip_code = 'apl:zip_code',
  tax_id = 'apl:tax_id',
  communication_name = 'apl:communication_name',
  email = 'apl:email',
  main_phone = 'apl:main_phone',
  code = 'apl:code',
  authorized_reselers_registration_via_link = 'apl:authorized_reselers_registration_via_link',
  search_use_form_bellow = 'apl:search_use_form_bellow',
  search_you_have_3_searches = 'apl:search_you_have_3_searches',
  contact_to_support = 'apl:contact_to_support',
  company_name = 'apl:company_name',
  country = 'apl:country',
  city = 'apl:city',
  vat_id = 'apl:vat_id',
  search = 'apl:search',
  select = 'apl:select',
  none_of_the_above = 'apl:none_of_the_above',
  reselect_company = 'apl:reselect_company',
  continue = 'apl:continue',
  address1 = 'apl:address1',
  address2 = 'apl:address2',
  address3 = 'apl:address3',
  add_address_line = 'apl:add_address_line',
  postal_code = 'apl:postal_code',
  company_phone_number = 'apl:company_phone_number',
  company_website = 'apl:company_website',
  contact_data = 'apl:contact_data',
  update_company_details = 'apl:update_company_details',
  user_details = 'apl:user_details',
  first_name = 'apl:first_name',
  last_name = 'apl:last_name',
  job_role = 'apl:job_role',
  sales = 'apl:sales',
  technical = 'apl:technical',
  marketing = 'apl:marketing',
  admin_and_finance = 'apl:admin_and_finance',
  purchasing = 'apl:purchasing',
  logistics = 'apl:logistics',
  job_level = 'apl:job_level',
  staff = 'apl:staff',
  low_management = 'apl:low_management',
  mid_management = 'apl:mid_management',
  executive_management = 'apl:executive_management',
  c_level = 'apl:c_level',
  work_phone_number = 'apl:work_phone_number',
  mobile_phone_number = 'apl:mobile_phone_number',
  general_manager_details = 'apl:general_manager_details',
  i_an_general_manager = 'apl:i_an_general_manager',
  corporate_email = 'apl:corporate_email',
  job_title = 'apl:job_title',
  job_function = 'apl:job_function',
  audit_risk_corporate = 'apl:audit_risk_corporate',
  bussiness_operations = 'apl:bussiness_operations',
  ceo = 'apl:ceo',
  it = 'apl:it',
  logistics_warehousing = 'apl:logistics_warehousing',
  pre_sales = 'apl:pre_sales',
  services_support = 'apl:services_support',
  education_training = 'apl:education_training',
  finance = 'apl:finance',
  legal = 'apl:legal',
  terms_and_conditions = 'apl:terms_and_conditions',
  authorized_partner_t_and_c = 'apl:authorized_partner_t_and_c',
  effective_date = 'apl:effective_date',
  business_survey = 'apl:business_survey',
  provide_business_survey = 'apl:provide_business_survey',
  do_you_sell_via_e_commerce_website = 'apl:do_you_sell_via_e_commerce_website',
  yes = 'apl:yes',
  no = 'apl:no',
  provide_your_e_commerce_site_url = 'apl:provide_your_e_commerce_site_url',
  do_you_sell_via_online_marketplaces = 'apl:do_you_sell_via_online_marketplaces',
  which_online_market = 'apl:which_online_market',
  provide_market_place_seller_id = 'apl:provide_market_place_seller_id',
  part_of_buying_group = 'apl:part_of_buying_group',
  if_yes_name_it = 'apl:if_yes_name_it',
  i_confirm_that_information_is_accurate = 'apl:i_confirm_that_information_is_accurate',
  i_accept = 'apl:i_accept',
  i_want_to_recieve_hp_information = 'apl:i_want_to_recieve_hp_information',
  confirm_company_check_details = 'apl:confirm_company_check_details',
  confirm_company_check_details_text2 = 'apl:confirm_company_check_details_text2',
  update_contact_details = 'apl:update_contact_details',
  end_registration = 'apl:end_registration',
  thankyou_for_your_interest = 'apl:thankyou_for_your_interest',
  email_validation_submit_details = 'apl:email_validation_submit_details',
  email_validation_info1 = 'apl:email_validation_info1',
  sent_email_invitation = 'apl:sent_email_invitation',
  read_and_accept = 'apl:read_and_accept',
  confirm_correct = 'apl:confirm_correct',
  accept_tc = 'apl:accept_tc',
  legal_name = 'apl:legal_name',
  export = 'apl:export',
  regards_thank_you = 'apl:regards_thank_you',
  team_name = 'apl:team_name',
  email_already_confirmed = 'apl:email_already_confirmed',
  email_already_confirmed_not_needed_actions = 'apl:email_already_confirmed_not_needed_actions',
  alr_eligible = 'apl:alr_eligible',
  reg_is_not_needed = 'apl:reg_is_not_needed',
  no_access = 'apl:no_access',
  do_you_still_want_enroll = 'apl:do_you_still_want_enroll',
  is_not_eligible = 'apl:is_not_eligible',
  search_description = 'apl:search_description',
  search_tax_id_requirements = 'apl:search_tax_id_requirements',
  search_company_name_requirements = 'apl:search_company_name_requirements',
  step_tc = 'apl:step_tc',
  former_party = 'apl:former_party',
  search_description_help = 'apl:search_description_help',
  no_vat_id = 'apl:no_vat_id',
  note_vatid = 'apl:note_vatid',
  company_trading_name = 'apl:company_trading_name',
  legal_name_same_as_trading = 'apl:legal_name_same_as_trading',
  note_company_legal_name = 'apl:note_company_legal_name',
  note_company_trading_name = 'apl:note_company_trading_name',
  company_not_found = 'apl:company_not_found',
  search_page_tax_id = 'apl:search_page_tax_id',
  terms_and_conditions_not_found = 'apl:terms_and_conditions_not_found',
  thank_you_for_interest = 'apl:thank_you_for_interest',
  your_reg_could_not_be_complete = 'apl:your_reg_could_not_be_complete',
  how_did_you_hear_about_apl = 'apl:how_did_you_hear_about_apl',
  hp_call_center = 'apl:hp_call_center',
  distributors_telemarketing_newsletter = 'apl:distributors_telemarketing_newsletter',
  distributors_website = 'apl:distributors_website',
  other_option = 'apl:other_option',
  documents_upload_form_tab_title = 'apl:documents_upload_form_tab_title',
  documents_upload_form_terms_and_condition_title = 'apl:documents_upload_form_terms_and_condition_title',
  documents_upload_form_selective_distribution_criteria_title = 'apl:documents_upload_form_selective_distribution_criteria_title',
  documents_upload_form_submit = 'apl:documents_upload_form_submit',
  document_history_tab_title = 'apl:document_history_tab_title',
  document_history_terms_and_condition_title = 'apl:document_history_terms_and_condition_title',
  document_history_selective_distribution_criteria_title = 'apl:document_history_selective_distribution_criteria_title',
  company_name_filter = 'apl:company_name_filter',
  country_filter = 'apl:country_filter',
  tax_id_filter = 'apl:tax_id_filter',
  search_button = 'apl:search_button',
  country_column = 'apl:country_column',
  legal_name_column = 'apl:legal_name_column',
  tax_id_column = 'apl:tax_id_column',
  print_hw_column = 'apl:print_hw_column',
  supplies_column = 'apl:supplies_column',
  bps_column = 'apl:bps_column',
  cps_column = 'apl:cps_column',
  guest_text = 'apl:guest_text',
  guest_download_btn = 'apl:guest_download_btn',
  guest_sdc_btn = 'apl:guest_sdc_btn',
  guest_registration_btn = 'apl:guest_registration_btn',
  guest_auth_btn = 'apl:guest_auth_btn',
  guest_header_title = 'apl:guest_header_title',
  guest_header_sub_title = 'apl:guest_header_sub_title',
  welcome_header_title = 'apl:welcome_header_title',
  guest_download = 'apl:guest_download',
  regect_text = 'apl:regect_text',
  resend_invite = 'apl:resend_invite',
  wrong_data_contact_with_hp = 'apl:wrong_data_contact_with_hp',
  notification_was_resent = 'apl:notification_was_resent',
  email_used_not_eligile = 'apl:email_used_not_eligile',
  email_used_not_eligile_use_invite_email = 'apl:email_used_not_eligile_use_invite_email',
  not_my_company = 'apl:not_my_company',
  not_my_company_check_info = 'apl:not_my_company_check_info',
  not_my_company_thank_you = 'apl:not_my_company_thank_you',
  end_partner = 'apl:end_partner',
  end_req_id = 'apl:end_req_id',
  reg_exists = 'apl:reg_exists',
  cont_perm_text = 'apl:cont_perm_text',
  phone = 'apl:phone',
  email_pixels_consent = 'apl:email_pixels_consent',
  thanks = 'apl:thanks',
  step2_nobtn = 'apl:step2_nobtn',
  step2_yesbtn = 'apl:step2_yesbtn',
  reg_attempts_left_before_the_break = 'apl:reg_attempts_left_before_the_break',
  reg_next_attempt_will_be_availabel_at = 'apl:reg_next_attempt_will_be_availabel_at',
  reg_over_attempts_search_counts = 'apl:reg_over_attempts_search_counts',
  company = 'apl:company',
  continue_registration_new_company = 'apl:continue_registration_new_company',
  onb_overall_progress = 'apl:onb_overall_progress',
  enrollment_id = 'apl:enrollment_id',
  partner_id = 'apl:partner_id',
  step1_alr_linked = 'apl:step1_alr_linked',
  step1_cl_reg = 'apl:step1_cl_reg',
  step1_cont_reg = 'apl:step1_cont_reg',
  section_is_not_needed = 'apl:section_is_not_needed',
  reg_was_removed = 'apl:reg_was_removed',
  fixed_number = 'apl:fixed_number',
  exevutive_management = 'apl:exevutive_management',

  // error recovery & hardened UI strings
  error_generic = 'apl:error_generic',
  error_try_refresh = 'apl:error_try_refresh',
  error_contact_support_with_id = 'apl:error_contact_support_with_id',
  error_incorrect_url = 'apl:error_incorrect_url',
  error_step_crashed = 'apl:error_step_crashed',
  error_form_config_not_found = 'apl:error_form_config_not_found',
  error_registration_create_failed = 'apl:error_registration_create_failed',
  error_tc_sorry = 'apl:error_tc_sorry',
  error_tc_contact_with_id = 'apl:error_tc_contact_with_id',
  try_again = 'apl:try_again',
  refresh_page = 'apl:refresh_page',
  registration_guide = 'apl:registration_guide',
  registration_guide_desc = 'apl:registration_guide_desc',
  troubleshoot_guide = 'apl:troubleshoot_guide',
  troubleshoot_guide_desc = 'apl:troubleshoot_guide_desc',
  need_help = 'apl:need_help',
  partner_registration_title = 'apl:partner_registration_title',

  // thank you page polish
  end_what_happens_next = 'apl:end_what_happens_next',
  end_review_timeline = 'apl:end_review_timeline',
  end_questions_contact = 'apl:end_questions_contact',
}
